
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`«Ich berate eine Nichtregierungsorganisation, und die wollen unbedingt, dass ich hinfliege. Ja, die Klimaerwärmung besorgt mich schon sehr. Aber die Reise ist ein Must. Ich finde, zum Vergnügen sollte man nicht mehr als zwei Flüge pro Jahr machen – und unter Vergnügen verstehe ich nicht am Strand liegen, sondern reisen, um Neues zu Lernen. Der Flug wird nicht klimakompensiert, mein Auftraggeber hat ihn gebucht.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;